import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFire, faCartShopping } from '@fortawesome/free-solid-svg-icons';
import formattedMoney from '../../utils/formatMoney';

const PLATFORM_STYLE = {
    shopee: { label: 'Shopee', bg: '#EE4D2D', color: '#fff' },
    lazada: { label: 'Lazada', bg: '#0F146B', color: '#fff' },
    tiktok: { label: 'TikTok', bg: '#010101', color: '#fff' },
};

const RANK_STYLE = [
    'bg-gradient-to-br from-yellow-400 to-orange-500 text-white', // #1
    'bg-gradient-to-br from-slate-300 to-slate-400 text-white',   // #2
    'bg-gradient-to-br from-amber-600 to-amber-700 text-white',   // #3
];

function TrendingHotProductCard({ product, onBuy, rank }) {
    const badge = PLATFORM_STYLE[product.platform] || { label: product.platform, bg: '#888', color: '#fff' };
    const rankClass = rank <= 3 ? RANK_STYLE[rank - 1] : 'bg-surface-raised text-content-2';

    return (
        <div
            className="w-40 flex-shrink-0 bg-surface rounded-xl shadow-sm overflow-hidden cursor-pointer transition-all duration-200 hover:-translate-y-0.5"
            onClick={() => onBuy(product)}
        >
            {/* Image */}
            <div className="relative w-full aspect-square">
                <img
                    src={product.productImage}
                    alt={product.productName}
                    className="w-full h-full object-cover"
                />
                {/* Rank badge */}
                {rank && (
                    <div className={`absolute top-1.5 left-1.5 w-6 h-6 rounded-full flex items-center justify-center text-[10px] font-black shadow ${rankClass}`}>
                        {rank <= 3 ? <FontAwesomeIcon icon={faFire} size="xs" /> : rank}
                    </div>
                )}
                {/* Platform badge */}
                <span
                    className="absolute bottom-0 left-0 right-0 text-center text-[9px] font-bold py-0.5"
                    style={{ backgroundColor: badge.bg, color: badge.color }}
                >
                    {badge.label}
                </span>
            </div>

            {/* Info */}
            <div className="p-2 flex flex-col gap-1">
                <p className="text-xs font-semibold leading-tight line-clamp-2 text-content">{product.productName}</p>
                <p className="text-sm font-bold text-red-500">{formattedMoney.format(product.productPrice)}</p>
                {product.commission > 0 && (
                    <span className="text-[10px] bg-green-50 border border-green-100 text-green-700 font-semibold px-1.5 py-0.5 rounded-full w-fit">
                        💰 Hoàn ~{formattedMoney.format(product.commission)}
                    </span>
                )}
                <div className="flex items-center gap-1 mt-0.5">
                    <FontAwesomeIcon icon={faCartShopping} className="text-content-3 text-[9px]" />
                    <span className="text-[10px] text-content-3">
                        {product.buyCount ? `${product.buyCount.toLocaleString()} đã mua` : 'Đang hot'}
                    </span>
                </div>
            </div>
        </div>
    );
}

export default TrendingHotProductCard;
